import React, { useState, useEffect, Fragment } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ReactTable from 'components/ReactTable/ReactTable.js';
import stylesAlert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { Link, useParams } from 'react-router-dom';
import Button from 'components/CustomButtons/Button.js';

import { wsGet, wsPost } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { Paper } from '@material-ui/core';
import moment from 'moment';
import { currency } from 'hooks/Pipe';
import resultState from './stateMigrate';
import { useAuth } from 'hooks/useAuth';
import { ConstantPermissions } from 'contexts/useConstant';
import SweetAlert from 'react-bootstrap-sweetalert';
import CardFooter from 'components/Card/CardFooter';
import { nPercent } from 'hooks/Pipe';

const useStyles = makeStyles({
  ...stylesAlert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  detail: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px',
      marginRight: '10px',
      color: '#000000bf',
      fontWeight: 'bold',
      fontSize: '15px',
    },
    marginBottom: '10px',
  },
  paper: {
    padding: '0px 11px 4px 10px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100 },
  { Header: 'Cód. Producto', accessor: 'ItemCode', width: 140 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Tipo', accessor: 'type', width: 130 },
  { Header: 'Tipo UM.', accessor: 'UgpName', width: 130, align: 'center' },
  { Header: 'UM.', accessor: 'quantity_unit', width: 80, align: 'center', align: 'right' },
  { Header: 'Cantidad', accessor: 'quantity', width: 100, align: 'center', align: 'right' },
  { Header: 'Precio', accessor: 'price', width: 100, align: 'right' },
  { Header: 'Monto Sin IGV', accessor: 'total_migrate', width: 150, align: 'right' },
  { Header: 'Monto', accessor: 'total_detail', width: 120, align: 'right' },
  { Header: '% Desc.', accessor: 'DiscPrcnt', width: 120, align: 'right' },
  { Header: 'Costo P. Sap', accessor: 'CostopromedioSAP', width: 120, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function SaleOrderDetails(props) {
  const classes = useStyles();
  const { hasPermission } = useAuth();
  const { id } = useParams();
  const { entity, idOrder, typeDetail, reload = undefined, showNotify } = props;

  const [order, setOrder] = useState({});
  const [orderDetails, setOrderDetails] = useState([]);
  const [processing, setProcessing] = useState(false);

  async function getOrder() {
    setProcessing(true);
    let response = await wsGet(entity ? entity : 'sale/order', idOrder ? idOrder : id);
    setProcessing(false);
    if (response.success) {
      setOrder(response.data);
      setOrderDetails(response.data.lines);
    }
  }

  const [alert, setAlert] = useState(null);
  function confirmAnnular(orderId) {
    const hideAlert = () => {
      setAlert(null);
    };
    setAlert(
      <SweetAlert
        input
        required={false}
        style={{ display: 'block', marginTop: '-100px' }}
        title={'¿Esta seguro de anular?'}
        onConfirm={(e) => {
          removeOrder(orderId, { ObservacionError: e });
          hideAlert();
        }}
        onCancel={hideAlert}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Ingrese el motivo por favor :)
      </SweetAlert>,
    );
  }

  async function removeOrder(orderId, data) {
    let response = await wsPost(`sale/order/${orderId}/annular`, data);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    getOrder();
  }, []);

  return (
    <Fragment>
      {alert}
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            Listado de detalles {typeDetail === 'NC' ? 'nota de crédito' : 'pedidos'} ({processing ? 'Cargando...' : order.id})
          </h4>
        </CardHeader>
        <CardBody>
          <GridContainer style={{ marginBottom: '15px' }}>
            {/* Vendedor */}
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Vendedor: </h5>
                <span>{processing ? '...' : order.SlpName}</span>
              </Paper>
            </GridItem>
            {/* CardName */}
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Cliente: </h5>
                <span>{processing ? '...' : order.CardName}</span>
              </Paper>
            </GridItem>
            {/* Dirección */}
            <GridItem xs={12} lg={6} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Dirección: </h5>
                <span>{processing ? '...' : order.Address2}</span>
              </Paper>
            </GridItem>
            {/* Total */}
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Total: </h5>
                <span>{processing ? '...' : currency(order.total_order)}</span>
              </Paper>
            </GridItem>
            {/* Estado */}
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Estado: </h5>
                <span>
                  {!!typeDetail === 'NC'
                    ? order.state_migrate === 'X'
                      ? 'Procesando'
                      : order.state_migrate == 'F'
                      ? 'Facturado'
                      : 'Otros'
                    : resultState(order.state_migrate)}
                </span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Fecha: </h5>
                <span>{processing ? '...' : moment(order.date_order).format('DD/MM/YYYY')}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Tipo: </h5>
                <span>{processing ? '...' : (order.U_SYP_MDTD || order.TipoDocumentoRef)}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Serie: </h5>
                <span>{processing ? '...' : (order.U_SYP_MDSD || order.U_SYP_MDSO)}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Número: </h5>
                <span>{processing ? '...' : (order.U_SYP_MDCD || order.U_SYP_MDCO)}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Zona: </h5>
                <span>{processing ? '...' : order.base_zone_description}</span>
              </Paper>
            </GridItem>

            {!order.PymntGroup ? undefined : (
              <GridItem xs={12} lg={4} className={classes.detail}>
                <Paper className={classes.paper}>
                  <h5>Término pago: </h5>
                  <span>{processing ? '...' : order.PymntGroup}</span>
                </Paper>
              </GridItem>
            )}

            {order.prog_sheet_distribution_id !== null && (
              <GridItem xs={12} lg={2} className={classes.detail}>
                <Paper className={classes.paper}>
                  <h5>Hoja reparto: </h5>
                  <span>{processing ? '...' : order.prog_sheet_distribution_id}</span>
                </Paper>
              </GridItem>
            )}
          </GridContainer>

          <ReactTable
            excelName="Detalles-de-pedidos"
            defaultWidth={1400}
            colorRow={(item) => {
              return item.type == 'Bonificación'
                ? '#43ff6b61'
                : item.type === 'Descuento'
                ? '#ff81001f'
                : '';
            }}
            columns={columns}
            data={orderDetails.map((orderDetail, i) => {
              return {
                num: !orderDetail.prom_promotion_id ? undefined : (
                  <div className="actions-right">
                    {i + 1}
                    <Link
                      to={`/admin/articulos/operaciones/promociones/${orderDetail.prom_promotion_id}`}
                      target="_blank"
                    >
                      <Visibility style={{ fontSize: 18 }} />
                    </Link>
                  </div>
                ),
                ItemCode: orderDetail.ItemCode,
                ItemName: orderDetail.ItemName,
                type:
                  orderDetail.type === 'B'
                    ? 'Bonificación'
                    : orderDetail.DiscPrcnt > 0 && orderDetail.DiscPrcnt < 100
                    ? 'Descuento'
                    : orderDetail.type === 'N'
                    ? 'Normal'
                    : 'Nota Crédito',
                UgpName: orderDetail.UgpName,
                quantity_unit: orderDetail.UM === 'PQT' ? orderDetail.quantity_pzas_um : 1,
                quantity:
                  orderDetail.UM === 'PQT'
                    ? orderDetail.quantity / orderDetail.quantity_pzas_um
                    : orderDetail.quantity,
                price:
                  orderDetail.UM === 'PQT'
                    ? currency(orderDetail.price * orderDetail.quantity_pzas_um)
                    : currency(orderDetail.price),
                total_migrate: currency(orderDetail.total_migrate),
                total_detail: currency(orderDetail.total_detail),
                CostopromedioSAP: currency(orderDetail.CostopromedioSAP),
                DiscPrcnt: nPercent(orderDetail.DiscPrcnt),
                actions: '',
              };
            })}
          />
        </CardBody>
        {order.state_migrate === 'X' &&
        (hasPermission(ConstantPermissions.SALE_ORDERS_ANNULAR) ||
          hasPermission(ConstantPermissions.SALE_ORDERS_ANNULAR_LIMITED)) ? (
          <CardFooter>
            <div style={{ width: '100%', textAlign: 'end' }}>
              <Button
                color={props.themeContext.buttonColorDanger}
                onClick={() => confirmAnnular(order.id)}
              >
                Anular
              </Button>
            </div>
          </CardFooter>
        ) : undefined}
      </Card>
    </Fragment>
  );
});
